import { useState, useEffect } from 'react';
import { api } from './api';

const TrashIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="#e57373" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14H6L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4h6v2" />
  </svg>
);

export default function OpenItemsPanel({ projectId }) {
  const [items, setItems] = useState([]);
  const [newDesc, setNewDesc] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function load() {
    try {
      setItems(await api.getOpenItems(projectId));
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [projectId]);

  async function handleAdd(e) {
    e.preventDefault();
    if (!newDesc.trim()) return;
    setLoading(true); setError('');
    try {
      const created = await api.createOpenItem({
        project_id:  projectId,
        description: newDesc.trim(),
        sort_order:  items.length,
      });
      setItems([...items, created]);
      setNewDesc('');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  async function handleToggle(item) {
    try {
      const updated = await api.updateOpenItem(item.id, { is_open: !item.is_open });
      setItems(items.map(i => i.id === item.id ? updated : i));
    } catch (err) {
      setError(err.message);
    }
  }

  async function handleDelete(id) {
    try {
      await api.deleteOpenItem(id);
      setItems(items.filter(i => i.id !== id));
    } catch (err) {
      setError(err.message);
    }
  }

  const openCount = items.filter(i => i.is_open).length;

  return (
    <div className="open-items-panel">
      <div className="panel-head">
        Open items · next week
        {openCount > 0 && <span className="panel-count">{openCount} open</span>}
      </div>

      {items.length === 0 && (
        <div className="panel-empty">No items yet — add one below</div>
      )}

      {items.map(item => (
        <div key={item.id} className={`open-item ${item.is_open ? '' : 'closed'}`}>
          <input
            type="checkbox"
            checked={!item.is_open}
            onChange={() => handleToggle(item)}
          />
          <span>{item.description}</span>
          <button
            className="trash-btn trash-sm"
            onClick={() => handleDelete(item.id)}
            title="Delete"
          >
            <TrashIcon />
          </button>
        </div>
      ))}

      <form onSubmit={handleAdd} className="add-item-row">
        <input
          type="text"
          value={newDesc}
          onChange={e => setNewDesc(e.target.value)}
          placeholder="Add an item…"
        />
        <button type="submit" disabled={loading || !newDesc.trim()}>
          {loading ? '…' : '+ Add'}
        </button>
      </form>

      {error && <p className="error-msg" style={{ marginTop: 6 }}>{error}</p>}
    </div>
  );
}
